import { SuggestApiResponseModel, SuggestModel } from '../models';
import { mapMetaPaginationAdapter } from './pagination.adapter';

export const suggestResponseAdapter = ({
  data,
}: SuggestApiResponseModel): SuggestModel => ({
  data: data.data,
  meta: mapMetaPaginationAdapter(data.meta.pagination),
});
